import { render, staticRenderFns } from "./TransportList.vue?vue&type=template&id=55457e56&"
import script from "./TransportList.vue?vue&type=script&lang=js&"
export * from "./TransportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports